import React from 'react'
import { DomainTableCell, DomainTableRow } from '../Steps.styled'

import { DomainTableColumn, DomainToSelect } from '../../CrossSaleModal.types'
import { DomainCellContent } from './DomainCellContent'

interface DomainRowProps {
  domain: DomainToSelect
  columns: DomainTableColumn[]
  isSelectionDisabled?: boolean
  isMonitoredDisabled?: boolean
  isNewlyCreated?: boolean
  selectDomain: () => void
  setIsMonitored: () => void
  setIsWordPress: () => void
}

export const DomainRow = ({
  domain,
  columns,
  isMonitoredDisabled,
  isSelectionDisabled,
  selectDomain,
  setIsMonitored,
  setIsWordPress,
}: DomainRowProps) => {
  const changeByAccessor = (accessor: string) => () => {
    switch (accessor) {
      case 'isSelected':
        selectDomain()
        break
      case 'wordpress':
        setIsWordPress()
        break
      case 'isBzMonitor':
        setIsMonitored()
        break
    }
  }

  const isDisabledByAccessor = (accessor: string) => {
    switch (accessor) {
      case 'isSelected':
        // newly created domains are selected by default because they already added to BZ
        return (isSelectionDisabled && !domain.isSelected) || domain.isNewlyCreated
      case 'isBzMonitor':
        return isMonitoredDisabled
      default:
        return false
    }
  }

  return (
    <DomainTableRow key={domain.id}>
      {columns.map((cell, indx) => (
        <DomainTableCell
          flexStart={cell.flexStart}
          css={{ flex: cell.flex }}
          key={cell.accessor}
          isPadded={columns.length === indx + 1}
        >
          <DomainCellContent
            cellType={cell.accessor}
            text={domain.address}
            status={!!domain[cell.accessor]}
            onChange={changeByAccessor(cell.accessor)}
            isDisabled={isDisabledByAccessor(cell.accessor)}
          />
        </DomainTableCell>
      ))}
    </DomainTableRow>
  )
}
